export const loadCommunicationPreferences = (adminEmail) => {
  return (dispatch, getState, { api }) => {
    return api.loadCommunicationPreferences(adminEmail).then(
      (data) => {
        return {
          wasSuccessful: true,
          preferences: data.result,
        };
      },
      (err) => {
        return { wasSuccessful: false };
      },
    );
  };
};
